import { createSlice } from "@reduxjs/toolkit";
import { submitContactMessage } from "./thunk";

export interface ContactMessagesState {
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string | null;
}

interface GeneralResponse {
  code: number;
  message: string;
  data: any;
}

const initialState: ContactMessagesState = {
  loading: false,
  error: null,
  success: false,
  message: null,
};

const contactMessagesSlice = createSlice({
  name: "contactMessages",
  initialState,
  reducers: {
    clearState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.message = null;
      })
      .addCase(submitContactMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        const response = action.payload as GeneralResponse;
        state.message = response.message || "Contact message submitted successfully!";
        state.error = null;
      })
      .addCase(submitContactMessage.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
});

export const { clearState } = contactMessagesSlice.actions;

export default contactMessagesSlice.reducer;
